import { getAuthorizeUrl } from "./get-authorize-url";
import { storeCallbackRedirectUrl } from "./store-callback-redirect-url";

export function login(): void {
  storeCallbackRedirectUrl();
  const authUrl = getAuthorizeUrl();
  window.location.replace(authUrl);
}
